export type PosQueueStatus = "pending" | "completed";

export const formatQueueLabel = (
  queueNumber?: number | string | null,
  fallback = "--"
): string => {
  const numericValue = Number(queueNumber);

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return fallback;
  }

  return String(Math.trunc(numericValue)).padStart(2, "0");
};

export const formatQueueStatusLabel = (
  status?: PosQueueStatus | string | null
): string => {
  if (!status) {
    return "Unknown";
  }

  return String(status)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (match) => match.toUpperCase());
};
